<div class="bg-light">
  <div class="container align-items-center min-vh-100">
    <div class="row justify-content-center">
      <div class="col-12 col-md-6 col-lg-5">
        <div class="card shadow-sm p-4 py-4" style="border: none; border-radius: inherit;">
          <div class="text-center mb-3">
            <img src="https://acexpress.com.mx/images/asesorcontable2020-256.png" style="max-width: 190px" alt="Asesor Contable"/>
          </div>
          <div class="text-center text-muted mb-2 fw-medium h5">
            Crear una cuenta de Asesor Contable
          </div>
          <form (ngSubmit)="crearUsuario()">
            <div class="mb-3 text-start">
              <label class="form-label mb-0">Usuario</label>
              <input type="email" name="email" autocomplete="email" [formControl]="emailControl" placeholder="Correo electrónico" class="form-control" [ngClass]="{'border border-danger form-control-danger': emailControl.hasError('emailError')}">
            </div>
            <div class="mb-3 text-start">
              <label class="form-label mb-0">Contraseña</label>
              <div class="position-relative">
                <input [type]="mostrarPassword ? 'text' : 'password'"  name="password" autocomplete="new-password" [formControl]="passwordControl" placeholder="Contraseña" class="form-control" [ngClass]="{'border border-danger form-control-danger': passwordControl.hasError('passwordError')}">
                <mat-icon [fontIcon]="mostrarPassword ? 'visibility' : 'visibility_off'" class="position-absolute end-0 me-2" style="cursor: pointer;" (click)="mostrarPassword = !mostrarPassword"></mat-icon>
              </div>
            </div>
            <div class="mb-3 text-start">
              <label class="form-label mb-0">Confirmar contraseña</label>
              <div class="position-relative">
                <input [type]="mostrarPasswordConfirm ? 'text' : 'password'" name="confirm-password" autocomplete="new-password" [formControl]="passwordConfirmControl" placeholder="Contraseña" class="form-control" [ngClass]="{'border border-danger form-control-danger': passwordControl.hasError('passwordError')}">
                <mat-icon [fontIcon]="mostrarPasswordConfirm ? 'visibility' : 'visibility_off'" class="position-absolute end-0 me-2" style="cursor: pointer;" (click)="mostrarPasswordConfirm = !mostrarPasswordConfirm"></mat-icon>
              </div>
            </div>
            <div class="text-danger my-3 fw-medium h6" *ngIf="mensajeError">{{ mensajeError }}</div>
            <div class="text-danger my-3 fw-medium h6" *ngIf="bloqMayusActivado"><small>El Bloq Mayús está activado</small></div>
            <button type="submit" mat-stroked-button class="w-100 fw-medium text-white" style="background-color: navy;">Regístrate</button>
          </form>
          <div class="text-center mt-3" style="cursor: pointer;">
            <a class="text-primary text-decoration-none fw-medium" (click)="iniciarSesion()">¿Ya tienes una cuenta? Inicia sesión</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
